// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9f5cc2e","453":"c3db55c9","455":"02592900","977":"643e62a8"}[chunkId] + ".chunk.js";
};